(ns app.front.view.workspace.address
  (:require [app.address.parser :as address-parser]
            [app.domain.address.model :as address-model]
            [app.front.ui :as ui]
            [app.front.util :as futil]
            [clojure.string :as str]
            [core.front.config :as front-config]
            [core.front.event :refer [<sub]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::parser
  :<- [:tr]
  :<- [::front-config/country]
  :<- [:language]
  (fn [[tr country language] [_ subdivision]]
    (address-parser/parser-fn (util/mmap tr country subdivision language))))

(rf/reg-event-fx ::set-address
  (fn [_ [_ set-addr-evt parse-address old-address new-full-address]]
    {:dispatch-debounce [{:id      ::set-address
                          :timeout 500
                          :action  :dispatch
                          :event   [::set-and-parse-address set-addr-evt parse-address old-address new-full-address]}]}))

(rf/reg-event-fx ::set-and-parse-address
  (fn [_ [_ set-addr-evt parse-address old-address new-full-address]]
    {:dispatch [set-addr-evt (merge (select-keys old-address [:address/address-source])
                                    (parse-address new-full-address)
                                    ;; do not trim & uppercase yet
                                    {:address/full-address new-full-address})]}))

(rf/reg-event-fx ::set-and-parse-final-address
  (fn [_ [_ set-addr-evt parse-address old-address new-full-address]]
    {:dispatch          [set-addr-evt (when (-> new-full-address str/trim str/blank? not)
                                        (merge (select-keys old-address [:address/address-source])
                                               (parse-address new-full-address)))]
     :dispatch-debounce [{:id     ::set-address
                          :action :cancel}]}))

(defmulti get-attr (fn [_ attribute _] attribute))

(defmethod get-attr :default [_ attribute address]
  (get address attribute))

(defmethod get-attr :address/street-type [tr attribute address]
  (when-let [value (get address attribute)]
    (tr [value])))

(defn address-input-fields [{:keys [tr address subdivision input-class field-wrapper-class field-css-classes set-addr-evt optional?]}]
  (let [parse-address (<sub [::parser (keyword subdivision)])]
    [:div.flex.flex-col
     (->> (address-model/local-address-attributes subdivision)
          (remove #{:address/unit-designator})
          (keep (fn [attribute]
                  (when-let [value (get-attr tr attribute address)]
                    [:div.flex.flex-col.mr-4.justify-between
                     {:class (get field-css-classes attribute (:default field-css-classes))}
                     [:span.bx--label (tr [attribute])]
                     [:span.text-sm.uppercase value]])))
          (into [:div {:class (or field-wrapper-class "flex mb-4")}])
          vec)

     [ui/text-input {:id         "address"
                     :class      input-class
                     :label-text (cond-> (tr [:address/full-address])
                                   optional? (str " (" (tr [:optional]) ")"))
                     :value      (get address :address/full-address)
                     :on-change  (fn [evt]
                                   (let [value      (futil/tval evt)
                                         has-value? (-> value str/trim str/blank? not)]
                                     ;; just update full-address, parsing is done on blur
                                     (rf/dispatch-sync [set-addr-evt (when has-value?
                                                                       (merge address
                                                                              {:address/full-address value}))])
                                     (when has-value?
                                       (rf/dispatch [::set-address set-addr-evt parse-address address value]))))
                     :on-blur    (fn [evt]
                                   (rf/dispatch [::set-and-parse-final-address
                                                 set-addr-evt
                                                 parse-address
                                                 address
                                                 (futil/tval evt)]))}]]))
